<script lang="ts">
	// @ts-nocheck
	import Button from '$lib/components/ui/button/button.svelte';
	import { tourContent } from '$lib/utils/tourContent';
	import * as Accordion from '$lib/components/ui/accordion';
	import { illustrationImages } from '$lib/utils/images';
	import { resolveInclusionIllustration } from '$lib/utils/tourPresentation';

	let { tour, rezdyLink } = $props();

	const legacyContent = tourContent.find((item) => item.productCode === tour.productCode);
	const structuredContent =
		tour.contentMode === 'rezdy-structured' && tour.parsedContent ? tour.parsedContent : null;
	let highlights = structuredContent?.itinerary || legacyContent?.accordionContent || [];
	let features = structuredContent?.inclusionGroups || legacyContent?.features || [];

	function getIllustration(feature) {
		const source = structuredContent
			? resolveInclusionIllustration({ productCode: tour.productCode, sectionKey: feature.key })
			: feature.image;
		return Object.entries(illustrationImages).find(([key]) => key === source)?.[1]?.default || null;
	}
</script>

{#if structuredContent?.highlights.length > 0}
	<section class="relative overflow-hidden">
		<div class="mx-auto max-w-7xl px-4 py-16 lg:py-24">
			<h2 class="font-heading text-2xl font-semibold tracking-tight lg:text-3xl">Highlights</h2>
			<div class="mt-10 grid gap-6 md:grid-cols-2">
				{#each structuredContent.highlights as highlight}
					<article class="rounded-2xl bg-muted p-6">
						<h3 class="font-heading text-xl font-semibold">{highlight.title}</h3>
						<!-- eslint-disable-next-line svelte/no-at-html-tags -- parsed Rezdy HTML is allowlist-sanitized -->
						<div class="prose mt-4 max-w-none">{@html highlight.html}</div>
					</article>
				{/each}
			</div>
		</div>
	</section>
{/if}

<!-- FEATURES -->
{#if features.length > 0}
	<section class="relative overflow-hidden">
		<div class="mx-auto max-w-7xl px-4 py-24">
			<h2
				class=" mt-10 scroll-m-20 pb-2 font-heading text-2xl font-semibold tracking-tight transition-colors first:mt-0 lg:text-3xl"
			>
				What's included?
			</h2>
			<div class="flex w-full flex-col py-12">
				<div class="flex grid-cols-1 flex-col gap-12 lg:flex-row">
					{#each features as feature, index}
						<div class="col-span-1 flex w-full flex-col">
							{#if getIllustration(feature)}
								<enhanced:img
									src={getIllustration(feature)}
									class="w-36"
									alt={feature.title}
									sizes="144px"
									loading="lazy"
								/>
							{/if}

							<Accordion.Root class="w-full  " value="item-0">
								<Accordion.Item value="item-{index}" class="">
									<Accordion.Trigger class="font-heading text-lg font-semibold"
										>{feature.title}</Accordion.Trigger
									>
									<Accordion.Content class="text-md">
										<div class="prose max-w-none">
											<!-- eslint-disable-next-line svelte/no-at-html-tags -- parsed Rezdy HTML is allowlist-sanitized; legacy HTML is repository-owned -->
											{@html feature.html || feature.content}
										</div>
									</Accordion.Content>
								</Accordion.Item>
							</Accordion.Root>
							<!-- <h3 class="mb-4 font-heading text-lg font-semibold lg:text-xl">{feature.title}</h3>
							{@html feature.content} -->
						</div>
					{/each}
				</div>
			</div>
		</div>
	</section>
{/if}

<!-- HIGHLIGHTS -->
{#if highlights.length > 0}
	<!-- ACCORDION -->

	<section class="relative overflow-hidden bg-[#194139]">
		<div class="mx-auto max-w-7xl px-4 py-12">
			<h2
				class="mx-auto mt-10 scroll-m-20 pb-2 text-center font-heading text-2xl font-semibold tracking-tight text-background transition-colors first:mt-0 lg:text-3xl"
			>
				Itinerary
			</h2>

			<div class="mx-auto max-w-3xl">
				<Accordion.Root type="single" class="w-full  py-12 text-background" value="item-0">
					{#each highlights as item, index}
						<Accordion.Item value="item-{index}" class="border-background/40">
							<Accordion.Trigger class="text-lg ">
								{#if structuredContent}
									{item.title}
								{:else}
									<!-- eslint-disable-next-line svelte/no-at-html-tags -- legacy itinerary titles are repository-owned -->
									{@html item.title}
								{/if}
							</Accordion.Trigger>
							<Accordion.Content>
								<div class="prose max-w-none">
									<!-- eslint-disable-next-line svelte/no-at-html-tags -- parsed Rezdy HTML is allowlist-sanitized; legacy HTML is repository-owned -->
									{@html item.html || item.content}
								</div>
							</Accordion.Content>
						</Accordion.Item>
					{/each}
				</Accordion.Root>
			</div>
			<div class="mx-auto w-full text-center">
				<Button
					data-sveltekit-noscroll
					href={rezdyLink}
					class="button-booking rezdy rezdy-modal pointer-events-auto mx-auto mt-8 w-44 rounded-full bg-tt-red px-6 text-lg font-semibold hover:bg-tt-red/90 "
					>Book now</Button
				>
			</div>
		</div>
	</section>
{/if}

<!-- Important information and unknown sections render beside the booking rail, in the
     Overview container on the tour page. -->
